import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class UrlConstantsService {

  environment = environment
  baseUrl = this.environment.baseUrl

  public API_DOCS = `${this.baseUrl}/api/v1/schema/swagger-ui`;

  public HEALTH_STATUS = `${this.baseUrl}/api/v1/public/health-status`;
  public NEWSLETTER_SUBSCRIBE = `${this.baseUrl}/api/v1/public/newsletter-subscribe`;
  public PUBLIC_KB_FEEDBACK = `${this.baseUrl}/api/v1/public/knowledge-base/feedback`;
  public PUBLIC_KB_FEEDBACK_COMMENT = (uuid: string) => `${this.baseUrl}/api/v1/public/knowledge-base/feedback/${uuid}/comment`;

  public USER_LOGIN_EMAIL = `${this.baseUrl}/api/v1/auth/login`;
  public USER_REGISTER_EMAIL = `${this.baseUrl}/api/v1/auth/register`;
  public USER_REFRESH_TOKENS = `${this.baseUrl}/api/v1/auth/token-refresh`;
  public USER_FORGET_PASSWORD = `${this.baseUrl}/api/v1/auth/forgot-password`;
  public USER_RESET_PASSWORD = `${this.baseUrl}/api/v1/auth/reset-password`;

  public OWN_ORGANIZATION = `${this.baseUrl}/api/v1/organizations/mine`;
  public OWN_ORGANIZATION_LOGO = `${this.baseUrl}/api/v1/organizations/mine/logo`;
  public OWN_ORGANIZATION_API_KEYS = `${this.baseUrl}/api/v1/organizations/mine/api-keys`;
  public OWN_ORGANIZATION_API_KEY_BY_ID = (keyId: string) => `${this.baseUrl}/api/v1/organizations/mine/api-keys/${keyId}`;
  public OWN_ORGANIZATION_MEMBERS = `${this.baseUrl}/api/v1/organizations/mine/members`;
  public OWN_ORGANIZATION_MEMBER_BY_ID = (uuid: string) => `${this.baseUrl}/api/v1/organizations/mine/members/${uuid}`;
  public OWN_ORGANIZATION_TRANSFER_OWNERSHIP = (uuid: string) =>
    `${this.baseUrl}/api/v1/organizations/mine/members/${uuid}/transfer-ownership`;
  public OWN_ORGANIZATION_TEAMS = `${this.baseUrl}/api/v1/organizations/mine/teams`;
  public OWN_ORGANIZATION_TEAM_BY_ID = (uuid: string) => `${this.baseUrl}/api/v1/organizations/mine/teams/${uuid}`;
  public OWN_ORGANIZATION_INVITATIONS = `${this.baseUrl}/api/v1/organizations/mine/invitations`;
  public OWN_ORGANIZATION_INVITATION_BY_ID = (uuid: string) =>
    `${this.baseUrl}/api/v1/organizations/mine/invitations/${uuid}`;
  public OWN_ORGANIZATION_ACCESS_REQUESTS = `${this.baseUrl}/api/v1/organizations/mine/access-requests`;
  public OWN_ORGANIZATION_ACCESS_REQUEST_ACTION = (uuid: string, action: 'approve' | 'dismiss') =>
    `${this.baseUrl}/api/v1/organizations/mine/access-requests/${uuid}/${action}`;
  public INVITATION = (token: string) => `${this.baseUrl}/api/v1/auth/invitations/${encodeURIComponent(token)}`;
  public INVITATION_ACCEPT = (token: string) =>
    `${this.baseUrl}/api/v1/auth/invitations/${encodeURIComponent(token)}/accept`;
  public ACCESS_REQUESTS = `${this.baseUrl}/api/v1/auth/access-requests`;

  public USERS = `${this.baseUrl}/api/v1/users`;
  public OWN_USER = `${this.baseUrl}/api/v1/users/me`;
  public OWN_USER_PASSWORD = `${this.baseUrl}/api/v1/users/me/password`;

  public PROJECTS = `${this.baseUrl}/api/v1/projects`;
  public PROJECT_BY_ID = (id: string) => `${this.baseUrl}/api/v1/projects/${id}`;
  public PROJECT_LOGO = (id: string) => `${this.baseUrl}/api/v1/projects/${id}/logo`;
  public PROJECT_STATUS_PAGE = (id: string) => `${this.baseUrl}/api/v1/projects/${id}/status-page`;
  public PROJECT_COMPONENTS = (id: string) => `${this.baseUrl}/api/v1/projects/${id}/components`;
  public PROJECT_COMPONENT_BY_ID = (projectId: string, componentId: number) =>
    `${this.baseUrl}/api/v1/projects/${projectId}/components/${componentId}`;
  public COMPONENT_MAINTENANCE_WINDOWS = (projectId: string, componentId: number) =>
    `${this.baseUrl}/api/v1/projects/${projectId}/components/${componentId}/maintenance-windows`;
  public COMPONENT_MAINTENANCE_WINDOW_BY_ID = (projectId: string, componentId: number, windowId: number) =>
    `${this.baseUrl}/api/v1/projects/${projectId}/components/${componentId}/maintenance-windows/${windowId}`;

  public PROJECT_MAINTENANCE_WINDOWS = (projectId: string) =>
    `${this.baseUrl}/api/v1/projects/${projectId}/maintenance-windows`;

  public PROJECT_API_KEYS = (id: string) => `${this.baseUrl}/api/v1/projects/${id}/api-keys`;
  public PROJECT_API_KEY_BY_ID = (projectId: string, keyId: string) =>
    `${this.baseUrl}/api/v1/projects/${projectId}/api-keys/${keyId}`;

  public PROJECT_NOTIFICATIONS = (id: string) => `${this.baseUrl}/api/v1/projects/${id}/notifications`;
  public PROJECT_NOTIFICATIONS_TEST = (id: string) => `${this.baseUrl}/api/v1/projects/${id}/notifications/test`;
  public PROJECT_TELEGRAM_LINK = (id: string) => `${this.baseUrl}/api/v1/projects/${id}/notifications/telegram/link`;
  public PROJECT_TELEGRAM_CHAT_BY_ID = (projectId: string, chatId: number) =>
    `${this.baseUrl}/api/v1/projects/${projectId}/notifications/telegram/chats/${chatId}`;


  public PROJECT_ANALYTICS = (id: string) => `${this.baseUrl}/api/v1/analytics/projects/${id}/analytics`;

  public ERROR_ISSUES = (projectId: string) =>
    `${this.baseUrl}/api/v1/error-tracking/projects/${projectId}/issues`;
  public ERROR_ISSUE_BY_ID = (projectId: string, issueId: string) =>
    `${this.baseUrl}/api/v1/error-tracking/projects/${projectId}/issues/${issueId}`;
  public ERROR_ISSUE_EVENTS = (projectId: string, issueId: string) =>
    `${this.baseUrl}/api/v1/error-tracking/projects/${projectId}/issues/${issueId}/events`;
  public ERROR_EVENT_BY_ID = (projectId: string, issueId: string, eventId: string) =>
    `${this.baseUrl}/api/v1/error-tracking/projects/${projectId}/issues/${issueId}/events/${eventId}`;
  public ERROR_STATS = (projectId: string) =>
    `${this.baseUrl}/api/v1/error-tracking/projects/${projectId}/stats`;
  public ERROR_KEYS = (projectId: string) =>
    `${this.baseUrl}/api/v1/error-tracking/projects/${projectId}/keys`;
  public ERROR_KEY_BY_ID = (projectId: string, keyId: string) =>
    `${this.baseUrl}/api/v1/error-tracking/projects/${projectId}/keys/${keyId}`;

  public ERROR_SOURCEMAPS = (projectId: string) =>
    `${this.baseUrl}/api/v1/error-tracking/projects/${projectId}/sourcemaps`;
  public ERROR_SOURCEMAP_BY_ID = (projectId: string, artifactId: string) =>
    `${this.baseUrl}/api/v1/error-tracking/projects/${projectId}/sourcemaps/${artifactId}`;

  public TRANSACTIONS = (projectId: string) =>
    `${this.baseUrl}/api/v1/error-tracking/projects/${projectId}/transactions`;
  public TRANSACTION_BY_ID = (projectId: string, transactionId: string) =>
    `${this.baseUrl}/api/v1/error-tracking/projects/${projectId}/transactions/${transactionId}`;
  public TRACING_STATS = (projectId: string) =>
    `${this.baseUrl}/api/v1/error-tracking/projects/${projectId}/tracing-stats`;
  public TRACE_BY_ID = (projectId: string, traceId: string) =>
    `${this.baseUrl}/api/v1/error-tracking/projects/${projectId}/traces/${traceId}`;


  public ADMIN_DASHBOARD_STATS = `${this.baseUrl}/api/v1/admin/dashboard/stats`;
  public ADMIN_PLATFORM_STATES = `${this.baseUrl}/api/v1/admin/platform-states`;
  public ADMIN_PLATFORM_STATE = (name: string) =>
    `${this.baseUrl}/api/v1/admin/platform-states/${encodeURIComponent(name)}`;

  constructor() { }
}
